import { FC } from "react";
import { faClockRotateLeft } from "@fortawesome/free-solid-svg-icons";
import OrderDetailsToolButtonComponent from "../../common/tool-button/order-details-tool-button.component";
import OrderDetailsToolsTranslations from "../../../../../languages/types/order/details/order-details-tools.translation";

type OrderDetailsHistoryComponentProps = {
  tools: OrderDetailsToolsTranslations;
  isActive: boolean;
  onSuccess: () => void;
};

const OrderDetailsHistoryComponent: FC<OrderDetailsHistoryComponentProps> = ({
  tools,
  isActive,
  onSuccess,
}) => {
  const { showOrderHistoryButtonTitle } = tools;

  return (
    <OrderDetailsToolButtonComponent
      onClick={onSuccess}
      icon={faClockRotateLeft}
      title={showOrderHistoryButtonTitle}
      isActive={isActive}
    />
  );
};

export default OrderDetailsHistoryComponent;
